var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnicalSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F24976"
    },
    cx: 256,
    cy: 256,
    r: 245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.24,
    y: 383.73,
    style: {
      fill: "#445EA0"
    },
    width: 89.53,
    height: 44.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.24,
    y: 383.73,
    style: {
      fill: "#2E4C89"
    },
    width: 19.842,
    height: 44.43
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M345.098,453.795c0,2.435-1.993,4.43-4.429,4.43H171.331c-2.436,0-4.43-1.995-4.43-4.43v-22.203 c0-2.435,1.994-4.43,4.43-4.43h169.337c2.436,0,4.429,1.995,4.429,4.43v22.203H345.098z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M186.744,453.795v-22.203c0-2.435,1.994-4.43,4.43-4.43h-19.842c-2.436,0-4.43,1.995-4.43,4.43 v22.203c0,2.435,1.994,4.43,4.43,4.43h19.842C188.737,458.225,186.744,456.229,186.744,453.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M506.198,42.867H5.803C2.611,42.867,0,45.479,0,48.672v330.254c0,3.191,2.611,5.803,5.803,5.803 h344.465v-17.345c0-1.767,1.436-3.203,3.203-3.203h13.486c2.754,0,5.62-2.039,6.525-4.641l2.547-6.119 c1.198-2.417,0.621-5.879-1.34-7.821l-9.518-9.443c-0.602-0.599-0.934-1.398-0.934-2.251s0.332-1.652,0.935-2.251l17.261-17.126 c0.605-0.601,1.414-0.932,2.279-0.932c0.864,0,1.674,0.331,2.279,0.932l9.517,9.443c1.219,1.21,3.102,1.934,5.035,1.934 c1.04,0,2.032-0.216,2.869-0.623l6.201-2.541c2.554-0.871,4.598-3.73,4.598-6.487v-13.319c0-1.767,1.436-3.203,3.202-3.203h24.439 c1.766,0,3.202,1.437,3.202,3.203v13.319c0,2.758,2.044,5.616,4.653,6.509l6.207,2.546c0.777,0.381,1.77,0.596,2.809,0.596 c1.934,0,3.816-0.723,5.036-1.933l9.518-9.443c0.605-0.601,1.414-0.932,2.278-0.932s1.673,0.331,2.278,0.932l17.258,17.127 c0.603,0.599,0.935,1.398,0.935,2.251c0,0.852-0.333,1.652-0.935,2.25l-9.515,9.444c-1.961,1.941-2.538,5.403-1.314,7.88 l2.542,6.114c0.882,2.547,3.747,4.586,6.503,4.586h13.487c1.767,0,3.203,1.436,3.203,3.203v14.788c0.631-0.928,1-2.046,1-3.246 V48.672C512,45.479,509.389,42.867,506.198,42.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M25.473,326.701c0,1.916,1.567,3.482,3.482,3.482h337.701l15.778-15.655 c0.605-0.601,1.414-0.932,2.279-0.932c0.864,0,1.674,0.331,2.279,0.932l9.517,9.443c1.219,1.21,3.102,1.934,5.035,1.934 c1.04,0,2.032-0.216,2.869-0.623l6.201-2.541c2.554-0.871,4.598-3.73,4.598-6.487v-13.319c0-1.767,1.436-3.203,3.202-3.203h24.439 c1.766,0,3.202,1.437,3.202,3.203v13.319c0,2.758,2.044,5.616,4.653,6.509l6.207,2.546c0.777,0.381,1.77,0.596,2.809,0.596 c1.934,0,3.816-0.723,5.036-1.933l9.518-9.443c0.605-0.601,1.414-0.932,2.278-0.932s1.673,0.331,2.278,0.932l7.692,7.634V99.913 H25.473V326.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9EAFC"
    },
    d: "M45.315,326.701V99.913H25.473v226.788c0,1.916,1.567,3.482,3.482,3.482h19.842 C46.882,330.184,45.315,328.617,45.315,326.701z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M249.615,253.532c-9.128-9.128-22.482-11.506-33.822-7.15l-38.259-38.259l-7.691,7.691 c-0.213,0.213-0.319,0.511-0.288,0.811c0.233,2.255-0.384,4.48-1.738,6.265c-0.252,0.332-0.272,0.785-0.05,1.138 c2.131,3.384,1.903,7.5-0.515,10.134l30.38,30.38c-4.357,11.339-1.979,24.695,7.15,33.824c7.902,7.902,19.084,11.038,29.911,8.389 c0.29-0.071,0.55-0.221,0.753-0.425c0.191-0.191,0.336-0.432,0.41-0.702c0.157-0.559,0-1.158-0.41-1.567l-19.516-19.518 l19.861-19.862l19.517,19.519c0.41,0.408,1.009,0.567,1.567,0.41c0.271-0.076,0.512-0.219,0.703-0.41 c0.204-0.205,0.353-0.464,0.424-0.756C260.654,272.616,257.518,261.435,249.615,253.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M148.928,208.658c1.713,0,3.415,0.502,4.924,1.452c0.163,0.103,0.348,0.153,0.533,0.153 c0.213,0,0.426-0.068,0.605-0.203c1.538-1.168,3.384-1.784,5.338-1.784c0.309,0,0.619,0.016,0.927,0.048 c0.034,0.003,0.069,0.005,0.103,0.005c0.264,0,0.519-0.105,0.707-0.293l7.692-7.692l-38.259-38.258 c4.356-11.34,1.978-24.695-7.15-33.822c-7.903-7.903-19.084-11.04-29.911-8.39c-0.291,0.072-0.549,0.221-0.753,0.424 c-0.192,0.191-0.336,0.432-0.412,0.704c-0.156,0.559,0.001,1.157,0.412,1.567l19.516,19.516l-19.862,19.863L73.821,142.43 c-0.409-0.41-1.009-0.566-1.567-0.41c-0.27,0.074-0.511,0.218-0.702,0.41c-0.205,0.204-0.354,0.463-0.425,0.754 c-2.65,10.826,0.487,22.009,8.388,29.91c9.129,9.129,22.483,11.507,33.824,7.151l30.381,30.381 C145.1,209.359,146.934,208.658,148.928,208.658z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#445EA0"
    },
    cx: 256,
    cy: 357.35,
    r: 15.667
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DC1D8"
    },
    d: "M483.047,72.461H28.955c-1.915,0-3.482,1.566-3.482,3.482v24.97h461.054v-24.97 C486.527,74.027,484.961,72.461,483.047,72.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#28A5A5"
    },
    d: "M48.797,72.461H28.955c-1.915,0-3.482,1.566-3.482,3.482v24.97h19.842v-24.97 C45.315,74.027,46.882,72.461,48.797,72.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M414.212,456.022c0,2.311,1.891,4.202,4.202,4.202h24.439c2.311,0,4.202-1.892,4.202-4.202v-13.318 c0-2.311,1.789-4.815,3.977-5.564l6.264-2.566c2.079-1.013,5.121-0.508,6.761,1.121l9.518,9.445c1.64,1.626,4.324,1.626,5.965,0 l17.258-17.129c1.642-1.629,1.642-4.293,0-5.921l-9.515-9.444c-1.643-1.628-2.146-4.656-1.121-6.729l2.568-6.174 c0.758-2.183,3.27-3.97,5.58-3.97h13.487c2.313,0,4.203-1.89,4.203-4.201v-24.189c0-2.311-1.891-4.203-4.203-4.203H494.31 c-2.311,0-4.822-1.786-5.58-3.97l-2.568-6.174c-1.024-2.072-0.522-5.1,1.121-6.727l9.515-9.444c1.642-1.628,1.642-4.292,0-5.921 l-17.258-17.127c-1.641-1.629-4.325-1.629-5.965,0l-9.518,9.443c-1.641,1.627-4.684,2.133-6.762,1.121l-6.263-2.566 c-2.188-0.748-3.977-3.252-3.977-5.563v-13.319c0-2.312-1.892-4.203-4.202-4.203h-24.439c-2.312,0-4.202,1.892-4.202,4.203v13.319 c0,2.311-1.789,4.814-3.977,5.563l-6.261,2.566c-2.076,1.012-5.121,0.508-6.762-1.121l-9.517-9.443 c-1.642-1.629-4.326-1.629-5.967,0l-17.262,17.127c-1.64,1.629-1.64,4.291,0,5.921l9.518,9.444c1.642,1.627,2.145,4.654,1.121,6.727 l-2.568,6.174c-0.76,2.184-3.27,3.97-5.581,3.97H353.47c-2.313,0-4.203,1.892-4.203,4.203v24.189c0,2.312,1.891,4.201,4.203,4.201 h13.486c2.312,0,4.821,1.787,5.581,3.97l2.569,6.176c1.024,2.07,0.522,5.099-1.119,6.727l-9.521,9.444 c-1.64,1.628-1.64,4.292,0,5.921l17.262,17.129c1.641,1.626,4.325,1.626,5.967-0.002l9.515-9.443 c1.641-1.629,4.684-2.134,6.762-1.122l6.263,2.567c2.188,0.748,3.977,3.252,3.977,5.564L414.212,456.022L414.212,456.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M430.634,418.341c-21.628,0-39.16-17.397-39.16-38.861c0.001-21.466,17.532-38.862,39.16-38.862 s39.16,17.397,39.16,38.86C469.794,400.943,452.262,418.341,430.634,418.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M403.388,379.479c0-19.456,14.401-35.569,33.202-38.417c-1.941-0.294-3.931-0.445-5.956-0.445 c-21.628,0-39.159,17.397-39.16,38.862c0,21.464,17.532,38.861,39.16,38.861c2.025,0,4.015-0.152,5.956-0.446 C417.789,415.046,403.388,398.933,403.388,379.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB722C"
    },
    d: "M430.634,424.646c-25.069,0-45.464-20.263-45.464-45.166c0.001-24.905,20.397-45.167,45.464-45.167 c25.069,0,45.465,20.262,45.465,45.165C476.099,404.383,455.703,424.646,430.634,424.646z M430.634,346.92 c-18.115,0-32.854,14.605-32.855,32.56c0,17.952,14.739,32.56,32.855,32.56c18.117,0,32.855-14.607,32.857-32.562 C463.491,361.525,448.751,346.92,430.634,346.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF10"
    },
    d: "M430.634,395.908c-9.143,0-16.554-7.357-16.554-16.429c0-9.076,7.411-16.431,16.554-16.431 c9.146,0,16.554,7.354,16.554,16.429C447.188,388.551,439.779,395.908,430.634,395.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9518"
    },
    d: "M425.992,379.479c0-6.987,4.401-12.94,10.598-15.315c-1.85-0.709-3.854-1.115-5.956-1.115 c-9.143,0-16.554,7.354-16.554,16.431c0,9.071,7.411,16.429,16.554,16.429c2.103,0,4.106-0.406,5.956-1.115 C430.394,392.418,425.992,386.466,425.992,379.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB722C"
    },
    d: "M430.634,402.211c-12.603,0-22.858-10.197-22.858-22.731c0-12.537,10.255-22.732,22.858-22.732 c12.605,0,22.858,10.195,22.858,22.73C453.489,392.014,443.237,402.211,430.634,402.211z M430.634,369.353 c-5.652,0-10.249,4.543-10.249,10.126c0,5.58,4.597,10.124,10.249,10.124s10.249-4.544,10.249-10.126 C440.883,373.897,436.286,369.353,430.634,369.353z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M140.441,226.608l10.829,10.829c0.899,0.899,1.565,1.945,2.003,3.06l4.692-4.692 c-1.104-0.48-2.134-1.172-3.012-2.051l-10.829-10.828c-0.899-0.9-1.584-1.926-2.056-3.008l-4.69,4.69 C138.514,225.053,139.556,225.724,140.441,226.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#445EA0"
    },
    d: "M252.734,130.761l-5.617-5.617c-0.625-0.624-1.785-0.818-2.578-0.432l-12.516,6.108 c-0.794,0.387-1.76,1.353-2.146,2.146l-5.565,11.407l-62.956,62.956c-2.776-0.288-5.633,0.589-7.779,2.616 c0.719,0.42,1.396,0.928,1.997,1.529l10.829,10.828c0.612,0.612,1.12,1.285,1.535,1.992c2.024-2.146,2.899-5,2.612-7.773 l62.953-62.953l11.41-5.566c0.794-0.387,1.76-1.353,2.146-2.146l6.107-12.517C253.553,132.546,253.357,131.386,252.734,130.761z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M167.749,235.1c-3.538,3.538-9.614,3.251-13.503-0.639l-10.829-10.828 c-3.889-3.89-4.177-9.966-0.639-13.504s9.614-3.251,13.503,0.639l10.829,10.828C170.999,225.485,171.287,231.561,167.749,235.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M430.432,147.983H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h131.871 c4.143,0,7.5,3.357,7.5,7.5C437.932,144.626,434.574,147.983,430.432,147.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M430.432,172.471H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h131.871 c4.143,0,7.5,3.357,7.5,7.5C437.932,169.113,434.574,172.471,430.432,172.471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69CDFF"
    },
    d: "M430.432,196.958H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h131.871 c4.143,0,7.5,3.357,7.5,7.5C437.932,193.601,434.574,196.958,430.432,196.958z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37C47A"
    },
    d: "M430.432,237.979H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h131.871 c4.143,0,7.5,3.357,7.5,7.5S434.574,237.979,430.432,237.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37C47A"
    },
    d: "M430.432,262.466H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h131.871 c4.143,0,7.5,3.357,7.5,7.5C437.932,259.108,434.574,262.466,430.432,262.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37C47A"
    },
    d: "M364.085,286.953H298.56c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h65.525 c4.143,0,7.5,3.357,7.5,7.5S368.228,286.953,364.085,286.953z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#293D7C"
    },
    d: "M105.584,297.266c-3.889,3.89-10.253,3.89-14.143,0l-10.829-10.828 c-3.889-3.89-3.889-10.253,0-14.143l46.394-46.393c3.889-3.89,10.253-3.89,14.142,0l10.829,10.829 c3.889,3.889,3.889,10.253,0,14.143L105.584,297.266z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M97.455,286.438c-3.889-3.89-3.889-10.253,0-14.143l45.043-45.043l-1.35-1.351 c-3.889-3.89-10.253-3.89-14.142,0l-46.394,46.393c-3.889,3.89-3.889,10.253,0,14.143l10.829,10.828 c3.889,3.89,10.253,3.89,14.143,0l1.35-1.35L97.455,286.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1A2B63"
    },
    d: "M149.278,216.629c3.538-3.538,9.614-3.251,13.503,0.639l-6.5-6.5 c-3.889-3.89-9.966-4.177-13.503-0.639s-3.25,9.614,0.639,13.504l6.497,6.496C146.028,226.24,145.742,220.166,149.278,216.629z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSupport);
export default __webpack_public_path__ + "static/media/technical-support.921b90a7dafefd69e9a850bd24116939.svg";
export { ForwardRef as ReactComponent };